import React, { type DetailedHTMLProps, type FC, type HTMLAttributes } from 'react';

import styled from 'styled-components';

const StyledDialogHeader = styled.div`
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #00000026;
`;

export const DialogHeader: FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (props) => {
  const { children, ...otherProps } = props;

  return (
    <StyledDialogHeader {...otherProps} data-dialog-header>
      {children}
    </StyledDialogHeader>
  );
};
